import React, {useEffect} from 'react';
import {useLocation} from 'react-router-dom';
import {connect, MapDispatchToProps, MapStateToProps, WithStore} from '../../redux/services/Imports';
import {ServiceData} from '../../redux/services/ServiceRedux';

import {IPageContent, Props} from './interfaces';
import './App.scss';
import './App-media.scss';
import Page404 from '../../pages/404/404';
import PageMain from '../../pages/PageMain/PageMain';
import Header from '../Header/Header/Header';

import Alert from '../Alert/Alert';
import {bodyAuto, CheckBlockedSend, htmlNoScroll, htmlScroll} from '../../services/GlobalFunctions';
import Cookies from '../Cookies/Cookies';
import Content from '../Content/Content';
import PageDelivery from '../../pages/PageDelivery/PageDelivery';
import PageAbout from '../../pages/PageAbout/PageAbout';
import PageCalculator from '../../pages/PageCalculator/PageCalculator';
import PagePolicy from '../../pages/PagePolicy/PagePolicy';
import PageContacts from '../../pages/PageContacts/PageContacts';
import PageTracking from '../../pages/PageTracking/PageTracking';
import PageLive from '../../pages/PageLive/PageLive';
import PageArticle from '../../pages/PageArticle/PageArticle';
import PageVacancies from '../../pages/PageVacancies/PageVacancies';
import PageVacancy from '../../pages/PageVacancy/PageVacancy';
import PageReviews from '../../pages/PageReviews/PageReviews';
import PageIntegration from '../../pages/PageIntegration/PageIntegration';
import PageDeliveryCur from '../../pages/delivery/PageDeliveryCur/PageDeliveryCur';
import Up from '../Up/Up';
import PageGeneric from "../../pages/PageGeneric/PageGeneric";
import {getPageName, isEmpty, loadPageContent, prepareOrder} from "../../services/content/functions";
import {APIWordpress} from "../../redux/services/APIRequestsWordpress";

import './../Footer/Footer.scss';
import './../Footer/Footer-media.scss';

const App = ({
               headerLoaded,
               advantagesSliderLoaded,
               logosPartnersLoaded,
               alertLoaded,
               widthWindow,
               widthWindowLoaded,
               offsetContentLoaded,
               state404Loaded,
               blockedSendLoaded,
               blogLoaded,
               blogMainLoaded,
               blogPopularLoaded,
               reviewsLoaded,
               textCardsLoaded,
               iconCardsLoaded,
               contactFormsLoaded
             }: Props) => {
  const location = useLocation();
  const [pageContent, setPageContent] =
    React.useState<IPageContent>({title: '', order: [], template: 'loading'});

  useEffect(() => {
    // hardcoded menu
    ServiceData.getHeader({headerLoaded});
    CheckBlockedSend(blockedSendLoaded);
    window.addEventListener('resize', handleResize);
    handleResize();

    console.debug('alert loaded', alertLoaded);
    console.debug('getting all');

    ServiceData.getAll({
      advantagesSliderLoaded,
      logosPartnersLoaded,
      alertLoaded,
      state404Loaded,
      blockedSendLoaded,
      blogLoaded,
      blogMainLoaded,
      blogPopularLoaded,
      reviewsLoaded,
      textCardsLoaded,
      iconCardsLoaded,
      contactFormsLoaded
    });

    const pagePath = getPageName(location.pathname);
    let content = loadPageContent(pagePath);
    if (isEmpty(content)) {
      console.debug(`no page content, calling api for ${pagePath}`);
      APIWordpress.getContentByPage(pagePath).then((data) => {
        console.debug('setting page content', data);
        setPageContent(data);
      }).catch((err) => alertLoaded(err));
    } else {
      console.debug(`getting page content from html`);
      const order = prepareOrder(content);
      content = {...content, order};
      console.debug('setting page content', content);
      setPageContent(content);
    }

    const utmParams = new URLSearchParams(window.location.search);
    document.cookie = `_ks_ds_utm_source=${utmParams.get('utm_source')}`;
    document.cookie = `_ks_ds_utm_medium=${utmParams.get('utm_medium')}; `;
    document.cookie = `_ks_ds_utm_campaign=${utmParams.get('utm_campaign')}; `;
    document.cookie = `_ks_ds_utm_content=${utmParams.get('utm_content')}; `;
    document.cookie = `_ks_ds_utm_term=${utmParams.get('utm_term')}; `;

    return () => window.removeEventListener('resize', handleResize);
  }, [location]);

  const handleResize = () => {
    widthWindowLoaded(window.innerWidth);

    const block = document.querySelector('.content') as HTMLElement;
    if (block) {
      offsetContentLoaded(block.getBoundingClientRect().x);
    }
  };

  const PageComponentByTemplate = (template: string) => {
    console.log('template', template, 'page content', pageContent);
    switch (template) {
      case 'main':
        return <PageMain/>;
      case 'blog':
        const article = {...pageContent.blog, title: pageContent.title}
        return <PageArticle article={article}/>;
      case 'vacancy':
        const vacancy = {...pageContent.vacancy, title: pageContent.title};
        return <PageVacancy vacancy={vacancy}/>;
      case '':
      case 'loading':
        return <></>;
      case 'page-templates/companya.php':
        return <PageAbout/>;
      case 'page-templates/calculator.php':
        return <PageCalculator/>;
      case 'page-templates/courier-delivery-msk.php':
        return <PageDeliveryCur pageContent={pageContent}/>;
      case 'page-templates/contacts.php':
        return <PageContacts/>;
      case 'page-templates/politika-konfidenczialnosti.php':
        return <PagePolicy title={pageContent.title} content={pageContent.simple!.content}/>;
      case 'page-templates/uslugi.php':
        return <PageDelivery pageContent={pageContent}/>;
      case 'page-templates/blog.php':
        return <PageLive/>;
      case 'page-templates/vacancies.php':
        return <PageVacancies/>;
      case 'page-templates/tracking.php':
        return <PageTracking/>;
      case 'page-templates/otzyvy.php':
        return <PageReviews pageContent={pageContent}/>;
      case 'page-templates/lichnyy-kabinet.php':
        return <PageIntegration/>;
      case '404':
        return <Page404/>;
      default:
        return <PageGeneric pageContent={pageContent}/>;
    }
  }

  return (
    <div className="app-content">
      <ScrollToTop state404Loaded={state404Loaded}/>
      <Alert/>
      <Cookies/>
      <Up/>
      {PageComponentByTemplate(pageContent.template)}
    </div>
  );
};

const ScrollToTop = ({state404Loaded}: { state404Loaded: Function }) => {
  const {pathname} = useLocation();

  useEffect(() => {
    state404Loaded(false);

    document.querySelectorAll('a').forEach((a) => {
      a.addEventListener('click', () => {
        if (!a.getAttribute('href')?.includes('#')) {
          htmlNoScroll();
        }
      });
    });

    window.scrollTo(0, 0);
    htmlScroll();
  }, [pathname]);

  bodyAuto();

  return null;
};

export default WithStore()(connect(MapStateToProps, MapDispatchToProps)(App));
